
import React from 'react';
import { DropdownWithUrl } from '../../elements/DropdownWithUrl'
import { MyInput } from '../../elements/MyInput'
import { PersianDatePicker } from '../../elements/PersianDatePicker'

export class AggregateMobileSearchForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);


        this.state = {};
        this.state.data = this.props.searchData;


        this.ExcelClick = this.ExcelClick.bind(this);

        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token
        };


    }

    ExcelClick() {
        var data = this.state.data;
        if (typeof this.props.onExcelClick === "function")
            this.props.onExcelClick(data);
    }

    handleTextChange(e, key) {

        this.state.data[key] = e;
        console.log(this.state.data);
        this.setState({});
    }


    handleSubmit(e) {
        e.preventDefault();
        var data = this.state.data;
        console.log(data);
        this.props.onSubmit(data);
    }


    componentDidMount() {

        if (this.getDropDownsUrl == null) {
            this.setState({
                isLoaded: true

            });
            return;
        }

        fetch(this.getDropDownsUrl, {
            method: 'GET',
            headers: this.headers
        }).then(res => {
            this.status = res.status;

            res.json().then((result) => {
                //                console.log(result);
                this.data = result;
                this.setState({
                    isLoaded: true,
                    status: res.status
                });
                //   console.log(result);
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,

                    });
                }
            );
        }
        );
    }


    render() {

        return (

            <form className="row" onSubmit={this.handleSubmit} ref="myRef">

                <br />
                <div div className="col-md-4">
                    <MyInput onChange={this.handleTextChange} label=" موبایل" name="mobileNO" ></MyInput>
                    <br />
                </div>


                <div div className="col-md-4">
                    <DropdownWithUrl label=" قرعه کشی" name="ghoreId" onChange={this.handleTextChange} headers={this.headers} url={"/api/v1/GetBreifGhore"} />
                    <br />
                </div>

                <div className="col-md-12 row ">

                    <div className="col-md-2 ">
                        <input type="submit" value="مشاهده" className="btn btn-primary btn-block btn-flat" />
                        <br />
                    </div>


                    <div className="col-md-2 ">
                        <input type="button" value="خروجی اکسل" onClick={this.ExcelClick} className="btn btn-primary btn-block btn-flat" />
                        <br />
                    </div>

                </div>

            </form>


        );

    }
}


// WEBPACK FOOTER //
// ./src/tables/aggregateMobile/AggregateMobileSearchForm.js